/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.inventory.list.controllers', [
  'ui.router',
  'ui.bootstrap',
  'ui.inflector',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.templates',
  'acme.common.service.permissions',
  'acme.common.factory.notice',
  'acme.common.factory.gridState',
  'acme.view.application.inventory.createModal.controllers',
  'acme.view.application.inventory.removeModal.controllers'
])

.controller('InventoryListController', ['$scope', '$filter', '$timeout', '$uibModal', '$q', 'ApiService', 'PermissionsService', 'HelpersService', 'TemplatesService', 'NoticeFactory', 'GridStateFactory', function($scope, $filter, $timeout, $uibModal, $q, ApiService, PermissionsService, HelpersService, TemplatesService, NoticeFactory, GridStateFactory) {

    $scope.inventoryList = {
      grid: {
        multiSelect: false,
        pageSize: 50,
        paginate: true,
        totalItems: 0,
        showFooter: true,
        enableRowSelection: false,
        useExternalPagination: true,
        useExternalSorting: true,
        columnDefs: [
          {
            field: 'id',
            visible: false
          },
          {
            field: 'order',
            visible: false
          },
          {
            field: 'name',
            displayName: 'Name',
            editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html'
          },
          {
            field: 'description',
            displayName: 'Description',
            editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html'
          },
          {
            field: 'sku',
            displayName: 'SKU',
            editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html'
          },
          {
            field: 'type',
            displayName: 'Type',
            cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.type | typeToLabel }}</div>'
          },
          {
            field: 'printTicket',
            displayName: 'Print Ticket',
            cellTemplate: '<div class="ui-grid-cell-contents">{{ (row.entity.printTicket) ? "Yes" : "No" }}</div>'
          },
          {
            field: 'price',
            displayName: 'Price',
            cellFilter: 'currency',
            editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html'
          },
          {
            field: 'salesChannels[0].enabled',
            displayName: 'Web',
            cellTemplate: '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>'
          },
          {
            field: 'salesChannels[1].enabled',
            displayName: 'POS',
            cellTemplate: '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>'
          },
          {
            field: 'salesChannels[2].enabled',
            displayName: 'Reseller',
            cellTemplate: '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><span data-ng-class="{ inactive: grid.appScope.programsDetailOverview.restrictMembers }" data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>'
          },
          {
            field: 'salesChannels[3].enabled',
            displayName: 'Customer Rep.',
            cellTemplate: '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>'
          },
          {
            field: 'salesChannels[5].enabled',
            displayName: 'Kiosk',
            cellTemplate: '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>'
          }
        ]
      },
      model: [],
      filtered: [],
      edited: {},
      addModal: {},

      searchQuery: '',
      searchTimer: false,

      editTimer: false,
      isEditing: false,
      isUpdating: false,

      notice: new NoticeFactory(),
      gridState: new GridStateFactory(),

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Add-ons',
          buttonRight: {
            permissions: 'ADDONS_CREATE',
            label: 'New Add-on',
            action: function() {
              $scope.inventoryList.create();
            }
          }
        });

        this.gridState.updateGridState(null, this.grid.pageSize, 'name', 'asc');

        this.getInventoryList(this.gridState.getGridState());

        if (PermissionsService.check('ADDONS_DELETE')) {
          this.grid.columnDefs.push({
            field: 'remove',
            displayName: 'Remove',
            width: 80,
            onCellNavClick: function(row, col) {
              $scope.inventoryList.remove(row.entity.id);
            },
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.remove(row.entity.id)" role="button">Remove<span class="sr-only">-Opens a dialog</span></a></div>'
          });
        }

        if (PermissionsService.check('ADDONS_UPDATE')) {
          this.grid.columnDefs.unshift({
            field: 'edit',
            displayName: 'Edit',
            width: 60,
            onCellNavClick: function(row, col) {
              $scope.inventoryList.edit(row.entity.id);
            },
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.edit(row.entity.id)" role="link">Edit<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>'
          });
        }

        $scope.$on('$destroy', $scope.$watch('inventoryList.searchQuery', this.onSearchQueryUpdate));

      },

      getTypeLabel: function(type) {

        var r;

        if (type === "doNotTrack") {
          r = 'Standard';
        }else if (type === "donation") {
          r = 'Variable Donation';
        }else{
          r = $filter('inflector')(type, "humanize");
        }

        return r;

      },

      getInventoryList: function (query) {
         ApiService.inventory.list(angular.extend({ addonTypes: 'doNotTrack' }, query)).then($scope.inventoryList.success.getInventoryList, $scope.inventoryList.error.getInventoryList);
      },

      hasItems: function() {
        return (this.filtered instanceof Array && this.filtered.length > 0);
      },

      findInventory: function(id) {
        var i, ii,
            r = false;

        for (i=0,ii=this.model.length;i<ii;i++) {
          if (parseInt(this.model[i].id, 10) === parseInt(id, 10)) {
            r = {
              index: i,
              item: this.model[i]
            };
            break;
          }
        }

        return r;
      },

      removeInventory: function(id) {
        this.model.splice(this.findInventory(id).index, 1);
        this.search();
      },

      search: function() {
        this.filtered = $filter('filter')(this.model, function(inventoryItem) {
          var name = inventoryItem.name + '|' + inventoryItem.sku,
            value = (name).toLowerCase();
          return (value.indexOf($scope.inventoryList.searchQuery.toLowerCase()) !== -1) ? inventoryItem : null;
        });
      },

      update: function(item) {
        ApiService.inventory.update(item).then(this.success.update, this.error.update);
      },

      remove: function(id) {
        var self = $scope.inventoryList;

        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/inventory/list/modals/removeInventory.tpl.html',
          size: 'md',
          controller: 'InventoryRemoveModalController',
          resolve: {
            currentInventory: function() {
              return self.findInventory(id).item;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (name) {
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();

          self.isUpdating = true;

          ApiService.inventory.remove(id).then(function(response) {
            var query = self.gridState.getGridState();

            query = HelpersService.decorate(query, { search: self.searchQuery });

            self.getInventoryList(query);
          }, self.error.remove);
        }, function () {
          // Do nothing
        });
      },

      create: function() {
        var self = $scope.inventoryList;

        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/inventory/list/modals/createInventory.tpl.html',
          size: 'lg',
          controller: 'InventoryCreateModalController',
          resolve: {
            inventory: function() {
              return self.model;
            },
            currentInventory: function() {
              return false;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (inventory) {
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();
          self.isUpdating = true;
          ApiService.inventory.create(inventory).then(function () {
            var query = self.gridState.getGridState();

            query = HelpersService.decorate(query, { search: self.searchQuery, addonTypes: 'doNotTrack' });

            self.getInventoryList(query);
          }, self.error.create);
        }, function () {
          // Do nothing
        });
      },

      edit: function(id) {
        var self = $scope.inventoryList,
            found = self.findInventory(id);

        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/inventory/list/modals/createInventory.tpl.html',
          size: 'lg',
          controller: 'InventoryCreateModalController',
          resolve: {
            inventory: function() {
              return self.model;
            },
            currentInventory: function() {
              return (found) ? found.item : false;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (inventory) {
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();
          self.isUpdating = true;
          self.update(inventory);
        }, function () {
          // Do nothing
        });
      },
      
      onDataGridPaginate: function (newPageNumber, pageSize) {
        var self = $scope.inventoryList,
            query = {};
        
        self.gridState.updateGridState(newPageNumber, pageSize);

        query = HelpersService.decorate(query, self.gridState.getGridState());
        query = HelpersService.decorate(query, { search: self.searchQuery });

        self.getInventoryList(query);
      },
      
      onDataGridSortChange: function (grid, columns) {
        var self = $scope.inventoryList,
            data = columns[0],
            query = {};
            
        if(data) {
          self.gridState.updateGridState(null, null, data.field, data.sort.direction);
        }

        query = HelpersService.decorate(query, self.gridState.getGridState());
        query = HelpersService.decorate(query, { search: self.searchQuery });

        self.getInventoryList(query);
      },

      processSalesChannels: function(list) {
        var i, ii;

        for (i=0,ii=list.length;i<ii;i++) {
          list[i].salesChannels = TemplatesService.orderSalesChannels(list[i].salesChannels);
        }

        return list;
      },

      success: {
        init: function(response) {
          $scope.inventoryList.model = response.data.payload;
          $scope.inventoryList.search();
        },
        getInventoryList: function (response) {
          var inventory = response.data.payload,
              self = $scope.inventoryList;

          self.model = self.processSalesChannels(inventory.list);
          self.isUpdating = false;
          self.filtered = angular.copy(self.model);
          //wait for next tick
          $scope.inventoryList.isUpdating = false;
          $timeout(function() {
            self.grid.totalItems = inventory.pagination.count;
          },0);
          if (!$scope.$$phase) {
            $scope.$apply();
          }
        },
        remove: function(response) {
          $timeout(function() {
            $scope.inventoryList.isUpdating = false;
          }, 500);
        },
        update: function(response) {
          var self = $scope.inventoryList;

          self.edited[response.data.payload.id] = false;

          var found = self.findInventory(response.data.payload.id);
          if (found) {
            self.model[found.index] = self.processSalesChannels([response.data.payload])[0];
            self.filtered[found.index] = angular.copy(self.model[found.index]);
          }

          $timeout(function() {
            self.isUpdating = false;
            self.isEditing = false;
          }, 500);
        }
      },

      error: {
        init: function(response) {},
        create: function(response) {
          $timeout(function() {
            $scope.inventoryList.isUpdating = false;
          }, 500);
        },
        remove: function(response) {
          $timeout(function() {
            $scope.inventoryList.isUpdating = false;
          }, 500);
        },
        update: function(response) {
          $timeout(function() {
            $scope.inventoryList.isUpdating = false;
          }, 500);
        },
        getInventoryList: function () {}
      },

      onGridDblClick: function(item) {
        $scope.inventoryList.edited[item.entity.id] = true;
      },

      onSearchQueryUpdate: function(n, o) {
        var self = $scope.inventoryList,
            query = self.gridState.getGridState();

        if (n !== o) {
          query = HelpersService.decorate(query, { search: self.searchQuery });

          if (self.searchTimer) {
            $timeout.cancel(self.searchTimer);
          }

          self.searchTimer = $timeout(function() {
            self.getInventoryList(query);
          }, 250);
        }
      }

    };
    

    $scope.inventoryList.init();

}])
.filter('typeToLabel', [ '$filter', function ($filter) {

  return function (text) {

    var r;

    if (text === "doNotTrack") {
      r = 'Standard';
    }else if (text === "donation") {
      r = 'Variable Donation';
    }else{
      r = $filter('inflector')(text, "humanize");
    }

    return r;

  };
}]);